<template>
  <tabs :tabList="tabList"
        @changeTab="changeTab">
    <keep-alive>
      <component :is="componentKey"
                 :isSetting="isSetting" />
    </keep-alive>
  </tabs>
</template>

<script>
import CurData from './CurData'
import CurrentConfig from './CurrentConfig'
import Sight from '@therapy/components/GlobalConfig/Sight'
import Vergence from '@therapy/components/GlobalConfig/Vergence'
import EyeMovement from '@therapy/components/GlobalConfig/EyeMovement'

import { mapState } from 'vuex'
import { timingSafeEqual } from 'crypto'

export default {
  components: {
    CurData,
    CurrentConfig,
    Sight,
    Vergence,
    EyeMovement,
  },
  props: {
    isSetting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      keyTitle: this.isSetting ? '设置' : '数据',
      componentKey: '',
    }
  },
  computed: {
    ...mapState({
      globalConfig: state => state.therapy.globalConfig,
    }),
    tabList() {
      let t = []
      if (this.isSetting) {
        t.push({
          name: '训练' + this.keyTitle,
          key: 'CurrentConfig',
        })
      } else {
        // t.push({
        //   name: '训练' + this.keyTitle,
        //   key: 'CurrentConfig',
        // })
        t.push({
          name: '训练数据',
          key: 'CurData',
        })
      }

      if (this.globalConfig.Sight) {
        t.push({
          name: '成像' + this.keyTitle,
          key: 'Sight',
        })
      }
      if (this.globalConfig.Vergence) {
        t.push({
          name: '融像' + this.keyTitle,
          key: 'Vergence',
        })
      }
      if (this.globalConfig.EyeMovement) {
        t.push({
          name: '眼动' + this.keyTitle,
          key: 'EyeMovement',
        })
      }
      return t
    },
  },
  created() {
    this.componentKey = this.tabList[0].key
  },
  methods: {
    changeTab(key) {
      this.componentKey = key
    },
  },
}
</script>

<style lang="scss">
.panel-box {
  width: 100%;
  h3 {
    margin-top: 10px;
    // font-size: 18px;
    cursor: pointer;
    position: relative;
    // padding: 8px;
    &:hover {
      color: #55acee;
      background: rgba(255, 255, 255, 0.1);
    }
    i {
      position: absolute;
      right: 8px;
      top: 13px;
      font-size: 16px;
    }
  }
  .panel-setting {
    padding: 0 8px;
    background: #2123;
    h4 {
      margin: 5px 0;
      font-size: 15px;
    }
    .container {
      display: inline-block;
      width: 100%;
      margin: 8px 0;
      .u-slider {
        width: 100%;
      }
      .color-bar {
        top: 69%;
      }
    }
  }
}
// .radio {
//   height: 40px;
//   display: flex;
//   justify-content: space-around;
//   align-items: center;
//   .option-radio {
//     display: none;
//   }
//   .option-radio + label {
//     display: inline-block;
//     height: 18px;
//     text-indent: 24px;
//     background: url('../../../assets/images/radio.png') no-repeat left center;
//     background-size: 18px 18px;
//     cursor: pointer;
//   }
//   .option-radio:checked + label {
//     background: url('../../../assets/images/radio-checked.png') no-repeat left
//       center;
//     background-size: 18px 18px;
//   }
// }
</style>

